<div class="timeline-container">

  <div class="hours" [style.top.rem]="baseHeightREM / 2">
    @for (item of hours; track item; let i = $index) {
      <div
        class="hour"
        [class.first-hour]="i == 0"
        [style.min-height.rem]="baseHeightREM"
        >
        {{ item }}
      </div>
    }


  </div>

  <div
    class="time-indicator left"
  [style.top.rem]="baseHeightREM / 2 +
  baseHeightREM * currentTimeMultiplier - 0.1
  "
  ></div>
  <div
    class="time-indicator right"
  [style.top.rem]=" baseHeightREM / 2 +
  baseHeightREM * currentTimeMultiplier - 0.1
  "
  ></div>

</div>
